import React, { useState } from "react";
import Sidebar from "./Sidebar";
// import SchoolFee from "../admissions/SchoolFee";
import Primary from "./primary";
import Stage3 from "./Stage3";
import Stage4 from "./Stage4";
import Stage5 from "./Stage5";
// import { useNavigate } from "react-router-dom";
// const navigate = useNavigate();

const Academics = () => {
  const [activePage, setActivePage] = useState("Primary");

  const renderContent = () => {
    switch (activePage) {
     case "Primary":
        return <Primary />;
      case "Sec (Key Stage 3)":
        return <Stage3 />;
      case "Sec (Key Stage 4)":
        return <Stage4 />;
      case "Sec (Key Stage 5)":
        return <Stage5 />;
      default:
        return <h2>Select a page</h2>;
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <Sidebar onSelect={setActivePage} />
      <div style={{ padding: "20px", flex: 1 }}>{renderContent()}</div>
    </div>
  );
};

export default Academics;
